<template>
  <div class="aboutUs">
    <sectionTitle :titleObj="titleObj"></sectionTitle>
    <div class="content">
      <div class="menu">
        <div @click="changeTabs(item)" class="menu-item flex-center" :class="{'menu-item-select':menuSelectName==item.name}" v-for="item in menu" :key="item.name">{{item.name}}</div>
      </div>
      <div style="flex:1">
        <!-- <div class="title">投诉查询指引</div> -->
        <div class="text" v-html="text"></div>
      </div>
    </div>
  </div>
</template>

<script>
import sectionTitle from '@/components/sectionTitle.vue';
import {queryForm} from '@/api/api.js';
export default {
  components:{
    sectionTitle
  },
  data(){
    return {
      menuSelectName:'投诉查询',
      titleObj:{
        title:'求助建议',
        subtitle:'SEEK HELP AND ADVICE'
      },
      menu:[
        {
          name:'投诉查询'
        },
        {
          name:'投诉渠道'
        },
        {
          name:'求助咨询'
        },
        {
          name:'行业互助'
        },
      ],
      textData:{},
      text:''
      // text:'一、受理范围</br>仅限于攀枝花市东区社会工作协会的会员申请查询。</br>二、申请材料</br>1、声明书（格式自拟，需注明单位名称、登记证号、近年是否有被有效投诉及举报等，加盖公章）</br>2、申请书（格式自拟，需注明单位名称、登记证号、事项缘由，加盖公章）</br>3、登记证书副本复印件（加盖公章）</br>4、其他材料：如登记机关开具的证明材料复印件。</br>三、申请渠道</br>广州市社会工作协会的会员可通过以下任一方式进行申请：</br>1.广州市社会工作协会网站平台申请。</br>2.邮件申请。将上述申请材料发送至协会监委会邮箱（gzsgjianweihui@163.com）。</br>四、其他</br>提交查询申请，经申请审核通过后（申请不通过将会有邮件或平台内回复通知），于申请之日（节假日的查询申请不予受理，顺延至最近的工作日）起3个工作日内，将会将查询函的扫描件按查询渠道（邮件或平台）回复至对应的账号。如需领取纸质原件，请携带申请材料的纸质原件、经办人身份证原件及复印件（加盖公章）到广州市社会工作协会（荔湾区环市西路68号）领取，到后请致电81984342联络领取。 </br></br>如有问题，请联系协会人员：</br>联系电话：020-81984342</br>联系地址：攀枝花市市东区环市西路68号4楼（地铁五号线“西村站”B出口、公交站“富力环市西苑(西村)”、“克山”公交站等）  </br></br>攀枝花东区社会工作协会</br>    2025年10月18日    '
    }
  },
  created(){
    this.getData()
  },
  methods:{
    changeTabs(data){
       this.menuSelectName=data.name
       if(!(this.textData[this.menuSelectName])){
          this.getData()
        }else{
          this.text=this.textData[this.menuSelectName]
        }
    },
    getData(){
      queryForm(
        {
          formKey: "qxd1W36P",
          queryId: "278",
          queryParams: {
            select1766544289030label: this.menuSelectName
          },
          size: 1,
          current: 0
        }
      ).then(res=>{
        if(res.data.code==200){
          this.textData[this.menuSelectName]=res.data.data.rows.length>0?res.data.data.rows[0].rich_text1766544337745:'暂无内容'
          this.text=this.textData[this.menuSelectName]
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.aboutUs{
  padding:0 10%;
  padding-bottom: 109px;
}
.content{
  gap:64px;
  display: flex;
  .menu{
    display: flex;
    flex-direction: column;
    gap:8px;
    .menu-item{
      width: 257px;
      height: 64px;
      background: #f3f1ef;
      cursor: pointer;
      font-size: 20px;
      color:#333333;
    }
    .menu-item-select{
      background: #ed9d26;
      color:#FFFFFF;
    }
  }
  .title{
    font-size: 36px;
    color: #333333;
    font-weight: bold;
    text-align: center;
    margin-bottom: 32px;
  }
  .introduce{
    font-size: 20px;
    color: #333333;
    line-height: 48px;
  }
  .text{
    font-size: 20px;
    color: #333333;
    line-height: 48px;
  }
}


</style>